import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type QuoteRequestLineActivePredictionDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.findPrediction
>;

export const fetchQuoteRequestLineActivePrediction = async (
  id: string | undefined,
): Promise<QuoteRequestLineActivePredictionDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.quoteRequestLines.findPrediction.query({
    params: { id },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
